<template>
  <LeafContainer :item="data" :isRoot="true" :isOpened="true" :state="state" @open="$emit('open', $event)" @click="$emit('click', $event)" @hover="$emit('hover', $event)" @zoom-item="$emit('zoom-item', $event)">
    <template slot-scope="{ item }">
      <slot :item="item" />
    </template>
  </LeafContainer>
</template>

<script>
import LeafContainer from './LeafContainer';
export default {
  props: ['data', 'state'],
  components: { LeafContainer },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisTree'] = this;
  },
}
</script>